var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAmLogout = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "127px",
    viewBox: "0 0 128 127",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 4")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-Copy",
    transform: "translate(-10.000000, -11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AM---Side-Menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "optimizer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Index-Replication"
  }, /*#__PURE__*/React.createElement("g", {
    id: "risks"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD39-Icon-Color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logout",
    transform: "translate(20.000000, 44.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1296618,86.609113 L56.5024155,96.2608696 L89.7391304,62.0347826 L56.5024155,27.8086957 L47.1296618,37.4604522 L64.2798068,55.1895652 L0,55.1895652 L0,68.88 L64.2798068,68.88 L47.1296618,86.609113 Z M106.666667,0 L13.3333333,0 C5.93333333,0 0,6.15 0,13.6666667 L0,41 L13.3333333,41 L13.3333333,13.6666667 L106.666667,13.6666667 L106.666667,109.333333 L13.3333333,109.333333 L13.3333333,82 L0,82 L0,109.333333 C0,116.85 5.93333333,123 13.3333333,123 L106.666667,123 C114,123 120,116.85 120,109.333333 L120,13.6666667 C120,6.15 114,0 106.666667,0 Z",
    id: "\\uD83D\\uDD39-Icon-Color"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#FFFFFF",
    fontFamily: "NHaasGroteskTXPro-Bd, Neue Haas Grotesk Text Pro",
    fontSize: 12.5,
    fontWeight: "bold",
    letterSpacing: -0.181818
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "LOG-OUT"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "LOG OUT")))))))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAmLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AM-Logout.5039184a.svg";
export { ForwardRef as ReactComponent };